export default "__VITE_ASSET__DMRDd6Wi__"